import React, {Component} from 'react'


export default class Filter extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            openFilter: '',
        }
        
        this.openFilter = this.openFilter.bind(this)
        this.closeFilter = this.closeFilter.bind(this)
        this.toggleFilter = this.toggleFilter.bind(this)
    }
    
    openFilter() {
        this.setState({ openFilter: 'opened' })
    }
    
    closeFilter() {
        this.setState({ openFilter: '' })
    }
    
    toggleFilter() {
        this.setState({ openFilter: this.state.openFilter ? '' : 'opened' })
    }
    
    renderListItems(cities, clickFunc) {
        return cities.map(city => (
          <li
            key={city}
            className='consultants__cities-filter-item'
            onClick={() => {
                clickFunc(city)
                this.closeFilter()
            }}>
              {city}
          </li>
        ))
    }
    
    
    render() {
        const {
            cities,
            currentCity,
            onChange,
        } = this.props
        const { openFilter } = this.state
        return (
          <div
            className="consultants__cities"
            // onTouchEnd={this.openFilter}
            onMouseEnter={this.openFilter}
            onMouseLeave={this.closeFilter}>
              <span>Filter</span>
              <div className="consultants__cities-filter">
          <span
            className="consultants__cities-filter-result"
            onTouchEnd={this.toggleFilter}>
            {currentCity}
          </span>
                  <ul
                    className={`consultants__cities-filter-list ${openFilter}`}>
                      {this.renderListItems(cities, onChange)}
                  </ul>
                  <img src={`${window.MS_Ajax.rootDir}/images/arrow.svg`} className="consultants__cities-filter-icon" alt="arrow icon"/>
              </div>
          </div>
        )
    }
}
